// src/components/Modal.js
import React from 'react';
import  './../styles/Modal.css'; // Ensure you have this CSS file for styling

// Creates a Modal overlay that allows other HTML structures within it
const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>×</button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
